<div class="editor-container" [class.tree-is-dragging]="dragDropService.isDragging()" cdkDropListGroup>
  <div
    cdkDropList
    [id]="rootListId"
    [cdkDropListData]="rootNodes()"
    (cdkDropListDropped)="drop($event)"
    class="node-list">
    @for (node of rootNodes(); track trackById($index, node)) {
    <pixl-generic-tree-node
      [node]="node"
      [level]="1"
      cdkDrag
      (cdkDragStarted)="dragDropService.dragStarted()"
      (cdkDragEnded)="dragDropService.dragEnded()">
    </pixl-generic-tree-node>
    }
  </div>

  @if (rootNodes().length === 0) {
  <div class="empty-state">
    {{ 'genericTree.noNodesFound' | transloco }}
  </div>
  }
</div>
